<div [ngClass]="{'disablePicker': disabled}">
  <input
    #datepicker
    type="text"
    [disabled]="disabled"
  >
</div>

